import requestInstance from '../../utils/instance-utils';

export const checkIfUserIsRegistered = async (email: string) =>
    requestInstance.get(`/user/is-user-registered/${email}`);

export const registerUser = async (email: string, password: string) =>
    requestInstance.post('/user/register-user', {
        email,
        password,
    });
